import gql from 'graphql-tag';

export const UPSERT_BROADCAST_TO_USER = gql`
  mutation UpsertBroadcastToUser($input: UpsertBroadcastToUserInput!) {
    broadcast {
      upsertBroadcastToUser(input: $input) {
        entity {
          broadcastToUserId
          broadcastId
          userProfileId
          status
        }
        error
        success
      }
    }
  }
`;
